enum SearchSourceType {
	ObjectMetadata,
	MetadataForm,
	FullText
}
export default SearchSourceType;
